import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';

import { brokerOption } from './prop_types';

export function BrokerSelect({
  broker,
  disabled = false,
  isInvalid,
  brokerSelectOptions,
  onSetBroker
}) {

  return (
    <Select
      className={`w-100 ${isInvalid ? 'select-invalid' : ''}`}
      classNamePrefix="react-select"
      defaultOptions={true}
      isDisabled={disabled}
      menuPlacement="auto"
      menuPortalTarget={document.body}
      options={brokerSelectOptions}
      placeholder={'Search by name'}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      value={broker}
      onChange={option => onSetBroker(option)}
    />
  );
}

BrokerSelect.propTypes = {
  broker: PropTypes.object,
  brokerSelectOptions: PropTypes.arrayOf(brokerOption).isRequired,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  onSetBroker: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  brokerSelectOptions: state.brokerSelectOptions || []
});

export default connect(mapStateToProps)(BrokerSelect);
